/**
 * Danh mục bộ khởi tạo cho người phát triển module (ADR-0113). `index.json` là tệp tĩnh do bước build sinh ra; bước
 * chuẩn hoá ở đây chỉ nhận mục đúng khuôn, để một mục sai không làm hỏng cả màn và tên tệp không dẫn ra ngoài thư mục.
 */
import type { BoKhoiTao, DanhMucBoKhoiTao } from '../types.ts';

export const THU_MUC_BO_KHOI_TAO = '/dev-kits';
export const TEP_DANH_MUC = `${THU_MUC_BO_KHOI_TAO}/index.json`;

/** Khớp tên tệp mà script sinh ghi: `extend-<mã module>.zip`, không thư mục con, không ký tự lạ. */
const DANG_TEP = /^extend-[a-z0-9]+(-[a-z0-9]+)*\.zip$/;

const chuoi = (v: unknown): string => (typeof v === 'string' ? v : '');
const so = (v: unknown): number => (typeof v === 'number' && Number.isFinite(v) && v >= 0 ? v : 0);

function mucHopLe(x: unknown): BoKhoiTao | null {
  if (!x || typeof x !== 'object') return null;
  const o = x as Record<string, unknown>;
  const file = chuoi(o.file);
  const code = chuoi(o.code);
  if (!code || !DANG_TEP.test(file)) return null;
  return {
    code,
    name: chuoi(o.name) || code,
    vendor: chuoi(o.vendor),
    version: chuoi(o.version),
    description: chuoi(o.description),
    permission_count: so(o.permission_count),
    route_count: so(o.route_count),
    file,
    size: so(o.size),
    sha256: chuoi(o.sha256),
  };
}

/** Ném lỗi khi không phải danh mục (ví dụ máy chủ trả trang HTML thay vì JSON). */
export function chuanHoaDanhMuc(raw: unknown): DanhMucBoKhoiTao {
  if (!raw || typeof raw !== 'object' || !Array.isArray((raw as { items?: unknown }).items)) {
    throw new Error('Danh mục bộ khởi tạo sai khuôn');
  }
  const o = raw as { sdk_version?: unknown; items: unknown[] };
  return { sdk_version: chuoi(o.sdk_version), items: o.items.map(mucHopLe).filter((m): m is BoKhoiTao => m !== null) };
}

export function duongDanTai(b: Pick<BoKhoiTao, 'file'>): string {
  return `${THU_MUC_BO_KHOI_TAO}/${b.file}`;
}
